<template>
  <div :style="{height:body_height}" class="main" ref="body">
    <div v-if="isComplete==1"  class="drawing_index">
      <div ref="cover" class="cover"></div>
      <!--  -->
      <div class="header dr_header">
        <img  :src="data.headimg" alt="">
        <div class="header-text">HI，欢迎你来画画</div>
      </div>
      <button @click="start" >开始测试</button>
    </div>
    <!-- 因为初始化需要skechpad所以这里换成v-show -->
    <div :style="{height:body_height}" v-show="isComplete==2" class="drawing-main">
      <!-- background  #393649 -->
      <div :class="{'bg':true,'isLocal':is_local}"></div>
      <!-- drawing content -->
      <div class="header">
        <img  :src="data.headimg" alt="">
        <div class="header-text">请根据自己的直觉画图</div>
      </div>
      <!-- 画板背景  Drawing board background -->
      <div :class="{'drawing-board-bg':true,'isLocal':is_local}">
        <!-- 画板  Drawing board -->
        <div class="drawing-board">
          <div class="toolbar">
            <div @click="undo" class="toolbar-menu">
              <img  src="https://open.xjy.cn/main/drawing_img/cancel.png" alt="">撤销
            </div>
            <div @click="clear(true)" class="toolbar-menu">
              <img  src="https://open.xjy.cn/main/drawing_img/clear.png" alt="">清除
            </div>
          </div>
          <!-- board -->
          <canvas id="drawing_board" class="drawing_board" ref="drawing_board"></canvas>
        </div>
      </div>
      <!-- 命名词 after word -->
      <div class="after-word">
        <input type="text" v-model="drawing_text" placeholder="请用一个词来形容你的画作" @blur="back_to_top()">
        <button v-if="drawing_num<6" @click='nextDrawing(drawing_num)'>下一幅</button>
        <button v-else @click='nextDrawing(drawing_num)'>完成</button>
      </div>
      <!-- footer  logo -->
      <div class="footer">
        <div class="left">
          <img src="https://open.xjy.cn/main/drawing_img/drawing_logo.png" alt="">
          <h5>通过绘画发现你的职场潜意识</h5>
        </div>
        <div class="right">
          <img  src="https://open.xjy.cn/main/drawing_img/drawing_sanjiao.png" alt="">
        </div>
      </div>
    </div>
    <!-- 完成测评展示和分享部分 -->
    <div ref="complete_main" :style="{height:body_height}" v-show="isComplete !=1 & isComplete != 2" class="drawing-main-complete">
      <!-- background  #393649 -->
      <div  :class="{'bg':true,'isLocal':is_local}"></div>
      <!-- drawing content -->
      <div class="header-two">
        <img :src="data.headimg" alt="">
        <div class="header-text">你的职场潜意识</div>
      </div>
      <!-- 画板背景  Drawing board background  -->
      <div  ref="swiper" :class="{'drawing-board-bg-two':true,'isLocal':is_local}">
        <van-swipe  @change="swipeChange" :initial-swipe="swipeNum" >
          <van-swipe-item v-show="swipeNum==index" :style="{'transform':'translateX('+(swiper_translateX*index)+'px)'}"  v-for="(item,index) in imgToData" :key="index">
            <div class="title">
              <h2 v-text="drawing.title[index]"></h2>
              <h2>（{{drawing.afterWord[index]}}）</h2>
            </div>
            <img :src="item" alt="">
          </van-swipe-item>
        </van-swipe>
      </div>
      <!-- 缩略图 -->
      <div class="thumbnail">
        <img :class="[swipeNum==index?'on':'']" @click="changeSwipe(index,item)" v-for="(item,index) in imgToData" :key="index" :src="item" alt="">
      </div>
      <!-- 解图参考： -->
      <p class="prompt-words-two" v-html="'解图参考：'+drawing.desc[swipeNum]"></p>
      <!-- 长按分享 -->
      <div class="share">
        <div class="share-text">
          <p>长按3秒</p>
          <p>将图片保存或转发好友</p>
          <p>点击右上角···转发测评</p>
        </div>
        <div id="qrcode"></div>
      </div>
      <!-- footer  logo -->
      <div class="footer">
        <div class="left">
          <img src="https://open.xjy.cn/main/drawing_img/drawing_logo.png" alt="">
          <h5>通过绘画发现你的职场潜意识</h5>
        </div>
        <div class="right">
          <img src="https://open.xjy.cn/main/drawing_img/drawing_sanjiao.png" alt="">
        </div>
      </div>
    </div>
    <button v-if="drawing_num>6" @click="$router.go(0)" class="restBtn">再画一次</button>
    <!-- 分享海报 -->
    <img v-if="drawing_num>6" class="postersLink" :src="postersLink" alt="">
    <!-- loading 加载 -->
    <van-popup v-model="isShow"  style="background-color: transparent;">
      <van-loading  vertical />
    </van-popup>

    <!-- 填写个人资料 -->
    <answer-collect style="z-index: 200;" :cid="data.cid" :query="$route.query" :extraObj="extraObj" v-if="userInfoBool" @saveuserinfo="saveUserInfo"></answer-collect>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import { setTimeout } from 'timers';
import { detail,index,report } from '@/api/drawing';
import {  shareCon} from "@/utils/wxconfig";
import { isLocal } from "@/utils/tools"
import { ceping_event,ceping58_save_extra,get_extra_info, } from '@/api/measurement'
import AnswerCollect from "@c/measurement/answer-collect";
import { phoneValidation } from '@/utils/validation'

// 引入图片
import drawing1 from "@a/drawing/drawing001.png";
import drawing2 from "@a/drawing/drawing002.png";
import drawing3 from "@a/drawing/drawing003.png";
import drawing4 from "@a/drawing/drawing004.png";
import drawing5 from "@a/drawing/drawing05.png";
import drawing6 from "@a/drawing/drawing06.png";

let drawing01 = "https://open.xjy.cn/main/drawing_img/drawing001.png";
let drawing02 = "https://open.xjy.cn/main/drawing_img/drawing002.png";
let drawing03 = "https://open.xjy.cn/main/drawing_img/drawing003.png";
let drawing04 = "https://open.xjy.cn/main/drawing_img/drawing004.png";
let drawing05 = "https://open.xjy.cn/main/drawing_img/drawing05.png";
let drawing06 = "https://open.xjy.cn/main/drawing_img/drawing06.png";

// 判读是否是本地
if(isLocal()) {
  drawing01 = drawing1;
  drawing02 = drawing2;
  drawing03 = drawing3;
  drawing04 = drawing4;
  drawing05 = drawing5;
  drawing06 = drawing6;
}

export default {
  data() {
    return {
      data:{},
      sketchpad: {},
      imgLinkList: [],
      w: 315, //宽度
      h: 300, //高度
      drawing_num: 1,
      drawing:{
        title: ['岗位适配','发展通路','职场人际','工作家庭平衡','能力发挥','未来自我'],
        afterWord: [],
        desc:['图形闭合、圆满程度代表匹配程度','通路是否畅通，是阶梯还是阻碍，是否有上升意象','上下代表与上下级关系，左代表同级关系，右代表与外部客户关系；画的多的可能是你关注的方面','左侧是家庭，右侧工作；画的多的是你的关注方面','圈里表示能力积累，圈外表示能力发挥；画的多的是你关注的方面','你内心未来的自己的样子']
      },
      drawing_text:'',
      imgToData:[],
      isComplete:1,
      swipeNum:0,
      postersLinkList:[],
      imgUrl:'',
      postersLink:'',
      isShow:false,
      type_obj:{},
      headimgurl:'',
      swiper_translateX:null,
      body_height:'100%',
      sketchpad_width: 0,
      sketchpad_height: 0,
      qrcode_len: 0,
      img_x: 0,
      img_y: 0,
      img_len: 0,
      // 存储答题数据
      extra:{},
      extraObj:{},
      userInfoBool:false,
      queArr:[],
    }
  },
  components: {
    AnswerCollect,
  },
  computed:{
    is_local(){
      return isLocal()
    }
  },
  methods: {
    start() {
      let bool = true;
      get_extra_info().then(data=>{
        for(let i=0;i<Object.keys(this.extraObj).length;i++){
          let item = Object.keys(this.extraObj)[i];
          if(data.extra[item]){
            this.extra[item] = data.extra[item];
          }else{
            bool = false;
          }
        }

        if(bool){
          this.startEvaluation();
        }else{
          this.userInfoBool = true;
        }
      });
    },
    // 提交个人信息和答题数据
    saveUserInfo(extra){
        if(extra) {
          this.extra = extra;
        }
        
        let obj = {};
        if(this.$route.query.sid){
            obj['sid'] = this.$route.query.sid;
        }
        for(let i=0;i<Object.keys(this.extraObj).length;i++){
          let item = Object.keys(this.extraObj)[i];
          if(!this.extra[item]){
            this.$toast(`${this.extraObj[item]}不能为空！`);
            return
          }else if(!phoneValidation(this.extra.phone)){
            this.$toast('手机号格式不正确！');
            return
          }else{
            obj[item] = this.extra[item];
          }
        }
        
        this.$toast.loading({
          mask: true,
          message: "提交中..."
        });

        ceping58_save_extra(obj).then(data=>{
            if (data.code == 10002) {
                this.$toast(data.msg);
                return;
            }
            this.userInfoBool = false;
            this.startEvaluation();
        });
    },
    // 解决ios唤起键盘页面不回弹
    getFocus() {
      $("input,textarea").on("blur", function() {
        window.scroll(0, 0);
      });
    },
    // 把绘画的生成图片
    toImgageHandle(){
      if(!this.postersLinkList[this.swipeNum]){
        this.isShow = true;
        let local = this.is_local;
        setTimeout(()=>{
          html2canvas(this.$refs.complete_main,{logging:false,}).then(canvas => {
            this.postersLink = canvas.toDataURL("image/png");
            this.postersLinkList.push(canvas.toDataURL("image/png"));
            this.isShow = false;
          });
        }, 200);
      }else{
        this.postersLink = this.postersLinkList[this.swipeNum];
      }
    },
    // 点击改变当前显示的的轮播图
    changeSwipe(index){
      this.swipeNum = index;
      this.swiper_translateX =  this.$refs.swiper.offsetWidth - 10;
      this.toImgageHandle();
    },
    // 改变轮播监听事件
    swipeChange(index){
      // 直接赋值会指向同一个内存地址，所有通过先转换为字符串，再转换为数组
      this.swipeNum = index;
      this.swiper_translateX =  this.$refs.swiper.offsetWidth - 10;
      this.toImgageHandle();
    },
    // 撤销
    undo() {
      this.sketchpad.undo();
      this.drawing_num == 1
      ? this.ImageToCanvas(drawing01, false):(this.drawing_num == 2
      ? this.ImageToCanvas(drawing02, false):(this.drawing_num == 3
      ? this.ImageToCanvas(drawing03, false):(this.drawing_num == 4
      ? this.ImageToCanvas(drawing04, false): ( this.drawing_num == 5
      ? this.ImageToCanvas(drawing05, false): (this.drawing_num == 6
      ? this.ImageToCanvas(drawing06, false): "")))));
    },
    // 清除
    clear(bool) {
      this.sketchpad.clear();
      this.sketchpad.strokes = [];
      if(!bool){
        return
      }
      this.drawing_num == 1? this.ImageToCanvas(drawing01):(this.drawing_num == 2? this.ImageToCanvas(drawing02):(this.drawing_num == 3? this.ImageToCanvas(drawing03):(this.drawing_num == 4? this.ImageToCanvas(drawing04): ( this.drawing_num == 5? this.ImageToCanvas(drawing05): (this.drawing_num == 6? this.ImageToCanvas(drawing06): "")))));
    },
    // 切换下一幅画
    nextDrawing(num){
      if(this.drawing_text == ''){
        this.$toast('形容词不能为空！');
        return
      }
      if(this.sketchpad.strokes.length<=0){
        this.$toast('请先根据自己直觉绘画！');
        return
      }

      this.canvasToImgage();
      this.drawing.afterWord.push(this.drawing_text);

      switch(num) {
        case 1:
            this.ImageToCanvas(drawing02);
            break;
        case 2:
            this.ImageToCanvas(drawing03);
            break;
        case 3:
            this.ImageToCanvas(drawing04);
            break;
        case 4:
            this.ImageToCanvas(drawing05);
            break;
        case 5:
            this.ImageToCanvas(drawing06);
            break;
        case 6:
            this.isComplete = false;
            this.generateQeCode();
            break;
      }
      this.drawing_text = '';
      this.drawing_num+=1;


    },
    // 生成二维码
    generateQeCode(){
      setTimeout(()=>{
        let qrcode = new QRCode(document.getElementById("qrcode"),{
          width: this.qrcode_len,
          height: this.qrcode_len,
        });
        qrcode.makeCode(window.location.href);
        // 生成海报
        this.toImgageHandle();
        this.generateReport();
      }, 500)
    },
    oneDrawing() {
      let sketchpad = new Sketchpad({
        element:'#drawing_board',
        width: this.sketchpad_width,
        height: this.sketchpad_height
      });
      this.sketchpad = sketchpad;
      // 修改颜色
      sketchpad.color = "#000000";
    },
    // 将图片画在canvas上
    ImageToCanvas(val, clear = true) {
      let image = new Image();
      image.src = val;
      let canvas = this.$refs.drawing_board;
      let ctx = canvas.getContext("2d");
      image.onload = () => {
        if(clear) {
          this.clear(false);
        }
        //  给img设置宽高，避免出现背景图超出100%宽度
        canvas.getContext("2d").drawImage(image, this.img_x, this.img_y, this.img_len, this.img_len); //0, 0参数画布上的坐标点，图片将会拷贝到这个地方
      }
    },
    // 保存绘画完毕的图
    canvasToImgage(){
      let canvas = this.$refs.drawing_board;
      this.imgToData.push(canvas.toDataURL("image/png"));
    },
    // InitData
    pullData(){
      detail().then(data=>{
        this.data = data;
        this.setTitle(data.headtitle);

        this.extraObj = data.extra || {};

        // 给wxconfig传对象
        this.type_obj.nickname = data.nickname;
        this.type_obj.evaluation_id = data.cid;
        this.type_obj.evaluation_name = data.headtitle;
        this.type_obj.evaluation_user_id = String(data.uid);
        this.type_obj.path = this.$route.path +'?share_uid='+data.uid+'&channel=ceping58';

        ceping_event({ lead_sid: this.$route.query.lead_sid,
          cid: data.cid,
          event: 'ViewIndex',
        }).then(res=>{
          // 页面访问统计
        });

        // 神策统计--打开页面时触发
        // sensors.track('evaluationPage', {
        //     evaluation_id: data.cid+'',
        //     evaluation_name: this.data.headtitle,
        //     evaluation_url: window.location.href,
        //     evaluation_page_title: this.data.headtitle,
        //     share_user_id: this.$route.query.share_uid ? this.$route.query.share_uid : "",
        //     channel_name: this.$route.query.channel ? this.$route.query.channel : ""
        // })

        shareCon("drawing", this, this.type_obj);
      });
    },
    // 开始测评
    startEvaluation(){
      index({
        share_uid: this.$route.query.uid || '',
        channel: this.$route.query.channel || ''
      }).then(data=>{
        this.isComplete = 2;
        this.setTitle(data.headtitle);
      });
    },
    // 生成报告
    generateReport(){
      report().then(data=>{
        // this.data = data;
      });
    },
    // 获取设备宽度给画板
    initCanvas(){
      //
      this.oneDrawing();
      this.ImageToCanvas(drawing01);
    },
    // 设置网页标题
    setTitle(val){
      // let title = this.$route.query.name;
      document.title = decodeURI(val);
    },
    back_to_top(){
      window.scrollTo(0,0);
    }
  },
  mounted(){
    let rate = 1.6;
    let width = this.$refs.body.offsetWidth;
    let height = this.$refs.body.offsetHeight;
    if(height < width * rate) {
      height = width * rate;
    }
    this.body_height = height +'px';
    // 需要设置的宽度/设计稿的宽度*设备可用区域的宽度
    this.sketchpad_width = 630 / 750 * width;
    this.sketchpad_height = 630 / 750 * width;
    this.qrcode_len = 140 / 750 * width;
    this.img_x = 120 / 750 * width;
    this.img_y = 106 / 750 * width;
    this.img_len = 390 / 750 * width;
    // 初始化获得skechpad的实例
    this.initCanvas();
  },
  created(){
    this.pullData();
  }
};
</script>

<style lang="scss" scoped>
// 生成海报
.postersLink{
  position: absolute;
  width: 100%;
  max-width: 750px;
  z-index: 120;
  top: 0;
  left: 0;
  opacity: 0;
}

.bg{
  background-image: url(https://open.xjy.cn/main/drawing_img/bg.png);
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  width: 100%;
  height: 100%;
  max-width: 750px;
  z-index: 1;
}
.bg.isLocal{
  background-image: url(../../assets/drawing/bg.png);
}
.main,.drawing-main {
  position: absolute;
  height: 100%;
  width: 100%;
  max-width: 750px;
  overflow: hidden;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  .drawing_index{
    position: absolute;
    width: 100%;
    height: 100%;
    top:0;
    left: 0;
    background: linear-gradient(0deg,rgba(224,223,227,1) 0%,rgba(221,220,224,1) 100%);
    .cover{
      background: url(https://open.xjy.cn/main/drawing_img/drawing_i_bg.png) center no-repeat;
      background-size: cover;
      width: 750px;
      height: 1334px;
    }
    button{
      position: absolute;
      margin: 0;
      top: 262px;
      right: 45px;
      width:180px;
      line-height:60px;
      border:2px solid rgba(57,54,73,1);
      background-color: #fff;
      box-shadow: 5px 5px 0px #393649;
      font-size: 32px;
      color: #393649;
      font-weight: bold;
    }
  }
  .header{
    position: relative;
    z-index: 99;
    display: flex;
    margin: 100px auto 60px;
    justify-content: center;
    img{
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background-color: #fff;
      margin-right: 32px;
    }
    .header-text{
      font-size: 32px;
      color: #393649;
      padding: 0 34px;
      height: 60px;
      line-height: 60px;
      position: relative;
      background-color:#fff;
      border-radius:4px;
    }
    .header-text:after{
      content: '';
      position: absolute;
      border-right: 14px solid #fff;
      border-top: 14px solid transparent;
      border-bottom: 14px solid transparent;
      top: 14px;
      left: -14px;
      width: 0;
      height: 0;
    }
  }
  .header.dr_header{
    position: absolute;
    z-index: 1;
    margin: 0;
    top: 40px;
    right:40px;
    .header-text{
      font-size: 26px;
    }
  }
  .drawing-board-bg{
    z-index: 99;
    position: relative;
    background-image: url(https://open.xjy.cn/main/drawing_img/drawing_bg.png);
    background-repeat: no-repeat;
    background-size: cover;
    width: 664px;
    height: 670px;
    margin: 0 auto;
    overflow: hidden;
    .drawing-board{
      background-color: #fff;
      text-align: center;
      width: 630px;
      height: 600px;
      margin: 50px 17px 22px;
      .toolbar{
        display: flex;
        align-items: center;
        padding: 28px 28px 0;
        .toolbar-menu{
          margin-right: 42px;
          font-size: 24px;
          color: #333333;
          display: flex;
          align-items: center;
          img{
            margin-right: 10px;
            width: 44px;
            height: 44px;
          }
        }
      }
      // board
      .drawing_board{
        // width: 630px;
        height: 530px;
      }
    }
  }
  .drawing-board-bg.isLocal{
    background-image: url(../../assets/drawing/drawing_bg.png);
  }
  .prompt-words{
    font-size: 26px;
    color: #333333;
    line-height:30px;
    margin: 40px auto 0;
    width: 664px;
  }
  .after-word{
    font-size: 30px;
    color: #393649;
    z-index: 99;
    position: relative;
    margin: 32px auto auto 40px;
    input{
      line-height: 60px;
      width: 420px;
      padding-left: 30px;
      border: none;
      margin-right: 65px;
    }
    button{
      width:180px;
      line-height:60px;
      border:2px solid rgba(57,54,73,1);
      background-color: #fff;
      box-shadow: 5px 5px 0px #393649;
      color: #393649;
    }
  }
  .footer{
    position: absolute;
    max-width: 750px;
    left: 40px;
    right: 40px;
    bottom:25px;
    z-index: 99;
    display: flex;
    .left{
      display: flex;
      align-items: center;
      font-size: 24px;
      color: #393649;
      img{
        width: 54px;
        height: 56px;
        margin-right: 10px;
      }
    }
    .right{
      margin-left: auto;
      display: flex;
      align-items: flex-end;
      img{
        width:24px;
        height: 24px;
      }
    }
  }
}
// 完成部分样式
.drawing-main-complete{
  position: absolute;
  height: 100%;
  width: 100%;
  max-width: 750px;
  overflow: hidden;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  .header-two{
    position: relative;
    z-index: 99;
    display: flex;
    margin: 30px auto 36px;
    justify-content: center;
    img{
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background-color: #fff;
      margin-right: 32px;
    }
    .header-text{
      font-size: 32px;
      color: #393649;
      padding: 0 82px;
      height: 60px;
      line-height: 60px;
      position: relative;
      background-color:#fff;
      border-radius:4px;
    }
    .header-text:after{
      content: '';
      position: absolute;
      border-right: 14px solid #fff;
      border-top: 14px solid transparent;
      border-bottom: 14px solid transparent;
      top: 14px;
      left: -14px;
      width: 0;
      height: 0;
    }
  }
  .drawing-board-bg-two{
    z-index: 130;
    position: relative;
    width: 650px;
    height: 620px;
    margin: 0 auto;
    overflow: hidden;
    background-color: #fff;
    border: 10px solid #F1F1F2;
    .van-swipe{
      height: 100%;
      text-align: center;
      .title{
        position: absolute;
        top: 34px;
        left: 50%;
        transform: translateX(-50%);
        h2{
          color: #333333;
          font-size: 32px;
          text-align: center;
          line-height: 1;
        }
        h2:last-child{
          margin-top: 18px;
        }
      }
      img{
        height: 452px;
        margin: 114px  auto 0;
      }
    }
  }
  .thumbnail{
    margin: 20px auto 0;
    width: 650px;
    display: flex;
    justify-content:space-between;
    position: relative;
    z-index: 130;
    img{
      width: 92px;
      height: 90px;
      background-color: #fff;
      border: 4px solid #fff;
    }
    img.on{
      border: 4px solid #b7a8e9;
    }
  }
  p.prompt-words-two{
    font-size: 26px;
    color:#333333;
    z-index: 99;
    position: relative;
    line-height:30px;
    margin: 40px auto 0;
    width: 650px;
  }
  .share{
    display: flex;
    align-items: flex-end;
    position: absolute;
    width: 650px;
    left: 50px;
    bottom: 96px;
    z-index: 99;
    .share-text{
      margin-left: auto;
      text-align: right;
      p{
        font-size: 22px;
        color: #333333;
        margin-right: 14px;
        z-index: 99;
        position: relative;
        text-align: right;
        margin-left: auto;
      }
    }
    #qrcode{
      border-radius:8px;
      overflow: hidden;
    }
  }
}
button.restBtn{
  position: absolute;
  width:180px;
  line-height:60px;
  border:2px solid rgba(57,54,73,1);
  background-color: #fff;
  box-shadow: 5px 5px 0px #393649;
  left: 50px;
  bottom: 96px;
  z-index: 125;
  color: #393649;
}
</style>
<style lang="scss">
.drawing-board-bg-two{
  .van-swipe{
    height: 100%;
    .van-swipe__indicators{
      bottom: 20px;
    }
    .van-swipe__indicator{
      background-color: #CCCCCC;
      border: 0;
      overflow: hidden;
      width: 16px;
      height: 16px;
    }
    .van-swipe__indicator.van-swipe__indicator--active{
      background-color: #666666;
    }
    .van-swipe__track{
      width: auto !important;
    }
  }
}
</style>

